// @flow

import React, { Component, Children, type Node } from 'react';
import CookieBanner from 'client/components/banner/CookieBanner';
import HtmlHead from 'client/components/htmlHead';
import NpnFooter from 'client/components/npnFooter';
import { fetchMembers } from 'client/actions/members';
import { fetchUser } from 'client/actions/user';
import { fetchIfpApps } from 'client/actions/ifpApps';
import { fetchLife } from 'client/actions/life';
import StrideHeaderWrapper from 'client/components/strideHeaderWrapper';
import 'client/styles/common.scss';

type Props = {
  children: Node,
};

class App extends Component<Props> {
  static fetchData({ dispatch }: { dispatch: Function }) {
    return Promise.all([
      dispatch(fetchMembers()),
      dispatch(fetchUser()),
      dispatch(fetchIfpApps()),
      dispatch(fetchLife()),
    ]);
  }

  render() {
    return (
      <StrideHeaderWrapper showPhone={false} noShadow>
        <div>
          <HtmlHead
            title="Stride Health - Life Insurance"
            description="Enjoy reliable coverage with maximum flexibility" />
          {Children.only(this.props.children)}
          <CookieBanner />
          <NpnFooter showPhone={false} shouldShowLadderDisclaimer />
        </div>
      </StrideHeaderWrapper>
    );
  }
}

export default App;
